import { render, staticRenderFns } from "./CouponGroupsCouponList.vue?vue&type=template&id=43e14c5d&scoped=true"
import script from "./CouponGroupsCouponList.vue?vue&type=script&lang=ts"
export * from "./CouponGroupsCouponList.vue?vue&type=script&lang=ts"
import style0 from "./CouponGroupsCouponList.vue?vue&type=style&index=0&id=43e14c5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e14c5d",
  null
  
)

export default component.exports